import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Col, Empty, Input, Row, Skeleton } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import Classcard from './classcard/classcard'
import Addclass from './addclass/addclass'
import { openNotificationWithIcon } from '../../../../utils/helper'
import { getClasses } from '../../../../api/class/class'
import useLanguages from '../../../../customhooks/languages/useLanguages'
import { RootState } from '../../../../store/store'
import { useSelector } from 'react-redux'

const Teacherclasses = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()
	const { languages, loadingLanguages } = useLanguages()

	const [loading, setLoading] = useState(false)
	const [data, setData] = useState([])
	const [showAddClass, setShowAddClass] = useState(false)

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	const requestParams = useMemo(() => {
		return {

		}

		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'Classes',
			}
		})

		// eslint-disable-next-line
	}, [])

	const fetchClasses = useCallback(
		async () => {
			try {
				setLoading(true)
				const res = await getClasses(requestParams, user?._id)
				const { data } = res?.data
				setData(data)
				setLoading(false)
			} catch (error: any) {
				setLoading(false)
				if (error?.response) {
					openNotificationWithIcon('error', 'Get Classes', `${error?.response?.data?.message || 'Something went wrong'}`)
				} else {
					openNotificationWithIcon('error', 'Get Classes', 'Something went wrong')
				}
			}
		},

		// eslint-disable-next-line 
		[requestParams],
	)

	const runReloadClasses = () => {
		fetchClasses()
	}


	useEffect(() => {
		fetchClasses()

	}, [fetchClasses])

	const closeShowAddClass = (reload?: boolean) => {
		setShowAddClass(false)
		if (reload === true) {
			fetchClasses()
		}
	}


	return (
		<div className='h-screen pr-10 mt-4'>
			<div className='mt-[1.8rem] flex justify-between items-center'>
				<div className='flex items-center px-2 rounded-lg bg-appcolorcream w-fit'>
					<img src="/img/vectors/search.svg" alt="search" />
					<Input
						size="small"
						placeholder='Search record'
						bordered={false}
						className="w-full mr-4 custom-search-record full-input"
						onChange={(e: any) => {
							console.log(e.target.value)
						}}
					/>
				</div>

				<div className='flex items-center'>
					<div className='rounded-xl bg-appcolorgreyfaint mr-[0.6rem] p-[0.5rem] mt-2'>
						<img src="/img/vectors/think.svg" alt="think" className='w-5 h-5 cursor-pointer' />
					</div>
					<Button
						className='custom-primary-two-btn extra-smaller-padding'
						onClick={() => {
							setShowAddClass(true)
						}}
					>
						+ Add New
					</Button>
				</div>
			</div>

			<div className='flex items-center justify-between mt-4'>
				<div className='flex items-center'>
					<p className='mr-2 text-sm text-appcolorwhitefaintsix'>
						Filter by Language
					</p>

					<img src="/img/vectors/curriculumpy.svg" alt="curriculumpy" className='' />
				</div>

				<div className='flex items-center cursor-pointer'>
					<div className='rounded-xl bg-appcolorgreyfaint mr-[0.6rem] p-[0.5rem]'>
						<img src="/img/vectors/filter.svg" alt="think" className='w-5 h-5 cursor-pointer' />
					</div>

					<p className='mr-2 text-sm text-appcolorwhitefaintsix'>
						Filter
					</p>
				</div>
			</div>

			<div className='pl-1 mt-7'>
				<Row gutter={16}>
					{
						loading ?
							<>
								{
									[1, 2, 3, 4, 5].map((item) => (
										<Col xs={24} md={24} lg={8} key={`loading-class-${item}`}>
											<Skeleton.Button
												active={true}
												size={'large'}
												shape={'square'}
												block={true}
												style={{
													height: '12.5rem',
													marginBottom: '1.8rem',
													borderRadius: '1rem',
													marginRight: '1rem'
												}}
											/>
										</Col>
									))
								}
							</>
							:
							<>
								{
									data.length === 0 ?
										<div className='flex justify-center w-full'>
											<Empty
												description={`You currently don't have any created class.`}
											/>
										</div>
										:
										data.map((item: any) => (
											<Col xs={24} md={24} lg={8} key={item?._id}>
												<Classcard
													details={item}
													runReloadClasses={runReloadClasses}
												/>
											</Col>
										))
								}
							</>
					}
				</Row>
			</div>

			{
				showAddClass ?
					<Addclass
						open={showAddClass}
						closeModal={closeShowAddClass}
						loadingLanguages={loadingLanguages}
						languages={languages}
					/>
					:
					null
			}

		</div>
	)
}

export default Teacherclasses